import { render, staticRenderFns } from "./keyWords.vue?vue&type=template&id=c0f82cbc&scoped=true&"
import script from "./keyWords.vue?vue&type=script&lang=js&"
export * from "./keyWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f82cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0f82cbc')) {
      api.createRecord('c0f82cbc', component.options)
    } else {
      api.reload('c0f82cbc', component.options)
    }
    module.hot.accept("./keyWords.vue?vue&type=template&id=c0f82cbc&scoped=true&", function () {
      api.rerender('c0f82cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonFile/detail/keyWords.vue"
export default component.exports